import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import axios from 'axios';
import { API_BASE_URL, API_KEY } from '../../../../constants';
import { useParams } from 'react-router-dom';
import axiosInstance from '../../../../axios';
function InviteRelativesForm({ isOpen, onClose, onInvite, onCancel, onInputChange }) {
  const { userId } = useParams();
  const [countries, setCountries] = useState([]);
  const [loading, setLoading] = useState(true);

  // Set the default country code to +91
  const defaultCountryCode = '+91';

  const [invite_list, setUser] = useState({
    countryCode: { value: defaultCountryCode, label: defaultCountryCode },
    mobile: '',
  });

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await axiosInstance.get(`${API_BASE_URL}countries/`, {
          headers: {
            'X-Api-Key': API_KEY,
          },
        });

        // Map the API response to an array of objects with value and label properties
        const countryOptions = response.data.data.map(country => ({
          value: country.dial_code,
          label: country.dial_code,
        }));

        setCountries(countryOptions);
      } catch (error) {
        console.error('Error fetching country codes:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchCountries();
  }, []);

  const handleCountryCodeChange = (selectedOption) => {
    setUser((prevUser) => ({
      ...prevUser,
      countryCode: selectedOption,
    }));
  };

  const handlemobileChange = (e) => {
    const newValue = e.target.value;
    setUser((prevUser) => ({
      ...prevUser,
      mobile: newValue,
    }));
  };

  const handleInviteClick = async () => {
    const data = {
      logged_in_user: userId,
      invite_list: [invite_list],
    };
    try {
      const response = await axiosInstance.post(
        `${API_BASE_URL}invite-friends/`,
        data,
        {
          headers: {
            'X-Api-Key': API_KEY,
            'Content-Type': 'application/json',
          },
        }
      );

      // Handle response as needed
    } catch (error) {
      console.error('Error inviting friends:', error);
    } finally {
      setLoading(false);
    }

    // Handle other logic after inviting
    onInvite(invite_list);
    onClose();
  };

  const handleCancelClick = () => {
    onCancel();
    onClose();
  };

  return isOpen ? (
    <div className="popup-overlay">
      <div className="popup">
        {loading ? (
          <p>Loading countries...</p>
        ) : (
          <>
            <span className="close-button" onClick={onClose}>
              X
            </span>
            <h2>Please invite friends</h2>

            <div className="input-container" style={{ display: 'flex', alignItems: 'center' }}>
              <label htmlFor="countryCode" style={{ marginRight: '10px', width: '132px' }}>
                Country Code:
              </label>
              <Select
                id="countryCode"
                value={invite_list.countryCode}
                onChange={handleCountryCodeChange}
                options={countries}
                placeholder="Select country code..."
              />
            </div>

            <div className="input-container" style={{ display: 'flex', alignItems: 'center', paddingTop: '10px' }}>
              <label htmlFor="mobile" style={{ marginRight: '10px', width: '200px' }}>
                Mobile Number:
              </label>
              <input
                type="text"
                id="mobile"
                value={invite_list.mobile}
                onChange={handlemobileChange}
                placeholder="Enter mobile number..."
              />
            </div>

            <div className="button-container">
              <button onClick={handleInviteClick}>Proceed</button>
              {<button onClick={handleCancelClick}>Cancel</button> }
            </div>
          </>
        )}
      </div>
    </div>
  ) : null;
}

export default InviteRelativesForm;
